import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import { apiRequest } from './utils/apiClient';

export const preferencesApi = {
  updateLanguagePreference: async (isAuth: boolean, locale: string, username?: string): Promise<void> => {
    const baseUrl = getConfig().LMS_BASE_URL;

    const url = isAuth
      ? `${baseUrl}/api/user/v1/preferences/${username}`
      : `${baseUrl}/lang_pref/update_language`;

    try {
      await apiRequest({
        url,
        isAuth: true,
        method: 'PATCH',
        data: { 'pref-lang': locale },
        contentType: 'application/merge-patch+json',
      });
    } catch (error) {
      logError('Error updating language preference', error);
    }
  },

  /** Reads one key; a user with no preferences answers `200 {}`, so an absent key is `null`. */
  getUserPreference: async (
    username: string,
    key: string,
    callback: (value: string | null) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/user/v1/preferences/${username}`;

    try {
      const data = await apiRequest<Record<string, string> | null>({
        url,
        isAuth: true,
        method: 'GET',
      });

      callback(data?.[key] ?? null);
    } catch (error) {
      logError('Error fetching user preference', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },

  /** Merge-patches a single preference. Never throws: callers must not be blocked by the write. */
  setUserPreference: async (username: string, key: string, value: string): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/user/v1/preferences/${username}`;

    try {
      await apiRequest({
        url,
        isAuth: true,
        method: 'PATCH',
        data: { [key]: value },
        contentType: 'application/merge-patch+json',
      });
    } catch (error) {
      logError('Error updating user preference', error);
    }
  },
};
